module.exports = __webpack_public_path__ + "static/media/uhi-1.a72a49f0.png";